import { AppLocation, arrayify } from '@lasso/shared/utils'

import { AppActiveWhen } from '@root-config/types'

export const isAppActive = (activeWhen: AppActiveWhen, location: AppLocation): boolean => {
  return arrayify(activeWhen).some((activeWhen) => {
    return typeof activeWhen === 'function' ? activeWhen(location) : location.pathname.startsWith(activeWhen)
  })
}
